import { getCookie, getSubscribersByAttribute, parseJwt } from '../../helpers/common';
import { USER_LOGIN_TOKEN } from '../../helpers/cookies';
import { openModalWindow, closeModalWindow, initialize } from '../../ui-components/editor/modalWindow';

const LIMIT_NICKNAMES_PER_REQUSETS = 20;

// TODO разделить бизнес-логику и логику состояний модалки
// TODO убрать связь через CSS классы
export default async ({ data, translations }) => {
  const subscribersListNode = document.querySelector('.ui-site-subscribers-list-modal__list');
  const subscribersListModal = document.querySelector('.ui-site-subscribers-list-modal');
  const subscribersListModalTitle = subscribersListModal.querySelector('.ui-site-subscribers-list-modal__title-text');
  const subscribersListDescription = subscribersListModal.querySelector('.ui-site-subscribers-list-modal__description');
  const subscribersListShowMoreButton = subscribersListModal.querySelector('.ui-site-subscribers-list-modal__button-show-more');
  const subscribersListShowMoreButtonText = subscribersListModal.querySelector('.ui-site-subscribers-list-modal__button-show-more-text');
  const showSubscribersList = document.querySelector('[data-type="footer-subscribers-button"]');
  const thankYouModal = document.querySelector('.ui-site-thank-you-modal');
  const showSubscribersListButton = document.querySelector('.ui-site-thank-you-modal__button-open-list');

  subscribersListModalTitle.innerText = translations['client.subscribers_list_modal.title'];
  subscribersListDescription.innerHTML = translations['client.subscribers_list_modal.description'];
  subscribersListShowMoreButtonText.innerHTML = translations['client.subscribers_list_modal.show_more_button'];

  const emptySubscribersListModal = document.querySelector('.ui-site-empty-subscribers-list-modal');
  const emptySubscribersListTitle = emptySubscribersListModal.querySelector('.ui-site-empty-subscribers-list-modal__title-text');
  const emptySubscribersListDescription = document.querySelector('.ui-site-empty-subscribers-list-modal__description');
  const emptySubscribersListButton = document.querySelector('.ui-site-empty-subscribers-list-modal__button');
  const emptySubscribersListButtonText = document.querySelector('.ui-site-empty-subscribers-list-modal__button-text');

  emptySubscribersListTitle.innerText = translations['client.empty_subscribers_modal.title'];
  emptySubscribersListDescription.innerText = translations['client.empty_subscribers_modal.description'];
  emptySubscribersListButtonText.innerText = translations['client.empty_subscribers_modal.button'];

  initialize(subscribersListModal);
  initialize(emptySubscribersListModal);

  sessionStorage.removeItem('emptyList');
  sessionStorage.removeItem('fullList');

  let lastAfterDateForUsers = '';
  let isEndOfSubscribers = false;
  let isPressedShowMoreButton = false;

  const userToken = getCookie(USER_LOGIN_TOKEN);
  const userData = parseJwt(userToken);

  const downloadAndShowMoreNicknames = async () => {
    const { merchantId, projectId } = data;

    const isLoading = subscribersListShowMoreButton.classList.contains('simple-button--loading');
    if (isLoading || isEndOfSubscribers || !isPressedShowMoreButton) {
      return;
    }
    subscribersListShowMoreButton.classList.add('simple-button--loading', 'ui-site-subscribers-list-modal__button-show-more--without-outline');

    const lastAfterDate = new Date(Date(lastAfterDateForUsers));
    lastAfterDate.setDate(lastAfterDate.getDate() - 1);
    const requestBody = {
      attribute: { key: 'subscription_purchase' },
      keys: ['subscription_purchase', 'subscriber_username'],
      after: lastAfterDate.toISOString(),
      limit: LIMIT_NICKNAMES_PER_REQUSETS,
      publisher_id: Number(merchantId),
      publisher_project_id: Number(projectId)
    };
    const { users, after } = await getSubscribersByAttribute(requestBody);
    subscribersListShowMoreButton.classList.remove('simple-button--loading', 'ui-site-subscribers-list-modal__button-show-more--without-outline');

    if (after === lastAfterDateForUsers) {
      subscribersListShowMoreButton.classList.add('ui-site-subscribers-list-modal__button-show-more--hidden');
      isEndOfSubscribers = true;
      return;
    }
    if (LIMIT_NICKNAMES_PER_REQUSETS > users.length) {
      subscribersListShowMoreButton.classList.add('ui-site-subscribers-list-modal__button-show-more--hidden');
      isEndOfSubscribers = true;
    }
    lastAfterDateForUsers = after;

    if (users && users.length) {
      users.forEach(user => {
        const userNickName = user.attributes.find(attribute => attribute.key === 'subscriber_username');
        if (!userNickName) {
          return;
        }

        const listItem = document.createElement('div');
        listItem.classList.add('ui-site-subscribers-list-modal__list-item');
        if (userData && (userData.sub === user.user_id)) {
          listItem.classList.add('ui-site-subscribers-list-modal__list-item--active');
        }

        listItem.innerText = userNickName.value;
        subscribersListNode.appendChild(listItem);
      });
    }
  };

  const clickHandler = async () => {
    const { merchantId, projectId } = data;

    closeModalWindow(thankYouModal);
    isEndOfSubscribers = false;
    
    const isEmptyList = sessionStorage.getItem('emptyList');
    const isFullList = sessionStorage.getItem('fullList');
    let anonymousUsersCount = 0;
    let result;

    if (isEmptyList !== '1' && isFullList !== '1') {
      const preloader = document.createElement('div');
      preloader.className = 'ui-site-modal-window__preloader';
      document.body.prepend(preloader);
      subscribersListShowMoreButton.classList.add('simple-button--loading', 'ui-site-subscribers-list-modal__button-show-more--without-outline');
      
      const requestBody = {
        attribute: { key: 'subscription_purchase' },
        keys: ['subscription_purchase', 'subscriber_username'],
        limit: LIMIT_NICKNAMES_PER_REQUSETS,
        publisher_id: Number(merchantId),
        publisher_project_id: Number(projectId)
      };
      const { users, after } = await getSubscribersByAttribute(requestBody);
      subscribersListShowMoreButton.classList.remove('simple-button--loading', 'ui-site-subscribers-list-modal__button-show-more--without-outline');

      if (users.length === LIMIT_NICKNAMES_PER_REQUSETS) {
        subscribersListShowMoreButton.classList.remove('ui-site-subscribers-list-modal__button-show-more--hidden');
        lastAfterDateForUsers = after;
      }
      result = users;
    }

    if (document.querySelector('.ui-site-modal-window__preloader') !== null) {
      document.querySelector('.ui-site-modal-window__preloader').remove();
    }

    if (isFullList === '1' && !result) {
      openModalWindow(subscribersListModal, 'SubscribersList');
      return;
    }

    if (isEmptyList === '1' && !result) {
      openModalWindow(emptySubscribersListModal, 'EmptySubscribersList');
      return;
    }

    if (result && result.length === 0) {
      sessionStorage.setItem('emptyList', '1');
      openModalWindow(emptySubscribersListModal, 'EmptySubscribersList');
    }

    if (result && result.length > 0) {
      subscribersListNode.innerText = '';
      sessionStorage.setItem('fullList', '1');
      openModalWindow(subscribersListModal, 'SubscribersList');

      result.forEach(user => {
        const listItem = document.createElement('div');
        listItem.className = 'ui-site-subscribers-list-modal__list-item';
        if (userData && (userData.sub === user.user_id)) {
          listItem.classList.add('ui-site-subscribers-list-modal__list-item--active');
        }

        const userNickName = user.attributes.find(attribute => attribute.key === 'subscriber_username');
        if (!userNickName) {
          anonymousUsersCount += 1;
        } else {
          listItem.innerText = userNickName.value;
          subscribersListNode.appendChild(listItem);
        }
      });

      if (anonymousUsersCount > 0) {
        const listItem = document.createElement('div');
        listItem.className = 'ui-site-subscribers-list-modal__list-item ui-site-subscribers-list-modal__list-item--last-item';
        listItem.innerText = translations['client.subscribers_list_modal.anonymous'].replace('{count}', anonymousUsersCount);
        subscribersListNode.appendChild(listItem);
      }

      const subscribersNumber = subscribersListNode.children.length;
      if (subscribersNumber >= 2) {
        subscribersListModal.classList.add('ui-site-subscribers-list-modal--grid');
      }
    }
  };

  emptySubscribersListButton.addEventListener('click', () => {
    closeModalWindow(emptySubscribersListModal);

    const firstSubscriptionButton = document.querySelector('div[data-external-id]');
    if (firstSubscriptionButton) {
      firstSubscriptionButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (showSubscribersList !== null) {
    showSubscribersList.addEventListener('click', clickHandler);
  }
  showSubscribersListButton.addEventListener('click', clickHandler);
  subscribersListShowMoreButton.addEventListener('click', () => {
    isPressedShowMoreButton = true;
    downloadAndShowMoreNicknames();
  });

  const modalBody = document.querySelector('.ui-site-subscribers-list-modal__body');
  modalBody.addEventListener('scroll', () => {
    const isEndOfSubscribersList = modalBody.scrollTop + modalBody.innerHeight >= modalBody.scrollHeight;
    if (isEndOfSubscribersList && isPressedShowMoreButton) {
      downloadAndShowMoreNicknames();
    }
  });
};
